import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseKey);
export const supabaseConfigError = isSupabaseConfigured
    ? ''
    : 'Missing Supabase environment variables. Check VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY';

if (!isSupabaseConfigured) {
    console.error(supabaseConfigError);
}

export const supabase = createClient(
    supabaseUrl || 'https://invalid.supabase.co',
    supabaseKey || 'invalid'
);

/** Get current authenticated user or throw */
export const getCurrentUser = async () => {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error || !user) throw new Error('Not authenticated');
    return user;
};
